<template>
  <v-container>
    <v-flex xs12 sm10 offset-sm1>
      <v-card elevation="2">
        <v-card-title style="background-color: #fcfcfc; padding: 15px; margin: 0px">
          <v-layout row wrap>
            <v-flex xs12 sm12 class="reg__custom__flex">
              <v-text-field
                type="text"
                outlined
                v-model="formName"
                label="Form Name"
                placeholder="Enter Form Name"
                ref="formName"
                value="this.formName"
                required
                :rules="formNameRules"
                dense
              >
              </v-text-field>
            </v-flex>

            <v-flex xs12 sm12 class="reg__custom__flex">
              <v-textarea
                label="Description"
                v-model="formDesc"
                outlined
                dense
              ></v-textarea>
            </v-flex>

            <v-flex
              xs12
              sm12
              md12
              class="reg__custom__flex"
              v-if="canSee('modifyForms')"
              style="text-align: center !important ; margin-top: 2px"
            >
              <v-btn
                v-if="addedQuestions && formTitle == 'New' && addedQuestions.length > 0"
                class="success"
                depressed
                tile
                :block="$mq == 'mobile' ? true : false"
                :disabled="isClicked"
                :loading="isClicked"
                @click="addForm"
              >
                Save
              </v-btn>

              <v-btn
                v-if="addedQuestions && formTitle == 'Edit' && addedQuestions.length > 0"
                class="success"
                depressed
                tile
                :block="$mq == 'mobile' ? true : false"
                :disabled="isClicked"
                :loading="isClicked"
                @click="addForm"
              >
                Update
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-layout row wrap>
            <!-- <v-flex xs12 sm1>
                </v-flex> -->

            <v-flex xs12 sm5 style="padding: 0px">
              <v-layout row wrap style="padding: 5px 20px">
                <v-card-title>
                  <span class="title font-weight-light" style="padding: 5px">Add Question</span>
                  <v-spacer></v-spacer>
                </v-card-title>

                <v-flex xs12 sm10 offset-sm1>
                  <v-textarea
                    outlined
                    placeholder="Add Question"
                    type="text"
                    v-model="editedItem.name"
                    required
                  >
                  </v-textarea>
                </v-flex>

                <div class="title font-weight-light" style="padding-left: 30px">Option Type</div>

                <v-flex xs12 sm10 offset-sm1 style="margin-top: -12px">
                  <v-radio-group v-model="editedItem.inputType" :mandatory="false">
                    <v-radio label="Text" color="primary" value="text"></v-radio>
                    <v-radio label="Yes/No" color="primary" value="boolean"></v-radio>
                    <v-radio label="Date and Time" color="primary" value="date"></v-radio>
                    <v-radio label="Attachment" color="primary" value="attachment"></v-radio>
                    <v-radio
                      label="Take Picture"
                      color="primary"
                      value="attachmentCapture"
                    ></v-radio>
                    <v-radio
                      label="Signature"
                      color="primary"
                      value="attachmentSignature"
                    ></v-radio>
                    <v-radio label="Number" color="primary" value="number"></v-radio>
                    <v-radio label="Option" color="primary" value="option"></v-radio>
                    <v-radio label="Checkbox" color="primary" value="checkbox"></v-radio>
                  </v-radio-group>
                </v-flex>

                <v-flex
                  v-if="editedItem.inputType == 'option' || editedItem.inputType == 'checkbox'"
                  xs8
                  sm10
                  offset-sm1
                  style="margin-top: -25px"
                >
                  <v-combobox v-model="editedItem.options" label="Create" multiple chips>
                  </v-combobox>
                </v-flex>

                <v-flex xs8 sm10 offset-sm1 style="margin-top: -30px">
                  <v-switch
                    color="primary"
                    :label="`Required: ${required.toString()}`"
                    v-model="required"
                  ></v-switch>
                </v-flex>
                <v-flex xs4 sm10 offset-sm1 style="margin-top: -15px" v-if="$mq != 'mobile'">
                  <v-btn
                    block
                    style="border-radius: 2px"
                    depressed
                    color="primary"
                    @click="addQuestion"
                    >Add</v-btn
                  >
                </v-flex>
                <v-flex
                  xs4
                  sm10
                  offset-sm1
                  style="margin-top: -15px; text-align: right !important"
                  v-else
                >
                  <v-btn style="border-radius: 2px; " depressed color="primary" @click="addQuestion"
                    >Add</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm7>
              <v-card elevation="0">
                <v-card-text style="padding: 5px 15px">
                  <v-layout row wrap>
                    <v-card-title>
                      <span class="title font-weight-light" style="padding: 5px 20px"
                        >Added Question</span
                      >
                      <v-spacer></v-spacer>
                    </v-card-title>

                    <v-flex xs12 sm12 v-if="addedQuestions.length > 0">
                      <draggable v-model="addedQuestions" @start="drag = true" @end="drag = false">
                        <v-card
                          elevation="1"
                          v-for="(item, id) in addedQuestions"
                          :key="id"
                          style="margin: 7px 3px"
                        >
                          <v-list-item :key="item.name" avatar>
                            <v-icon class="drag_icon">drag_indicator</v-icon>

                            <v-list-item-content style="padding: 8px 8px 7px 4px">
                              <v-list-item-title class="form_title"
                                >Question: {{ item.placeHolder }}</v-list-item-title
                              >
                              <p class="form_subtitle">Input Type: {{ item.fieldLabel }}</p>
                              <p class="form_subtitle">
                                Required : {{ item.required ? "Yes" : "No" }}
                              </p>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-btn icon ripple>
                                <v-icon color="red" small @click="deleteItem(item)">
                                  delete
                                </v-icon>
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                        </v-card>
                      </draggable>
                    </v-flex>

                    <v-flex xs12 sm12 style="text-align: center; margin-top: 20px" v-else>
                      <v-icon :size="70" color="primary">
                        assignment
                      </v-icon>
                      <p
                        style="font-size: 14px; color: #242424; letter-spacing: 0.5px; font-weight: 500"
                      >
                        No added questions
                      </p>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- <v-flex xs12 sm12 class="reg__custom__flex" v-if="canSee('modifyForms')"  >
                  <v-btn v-if="addedQuestions && formTitle == 'New' && addedQuestions.length > 0 "
                  class="success" x-large block depressed tile
                  :block="$mq == 'mobile' ? true : false"
                  :disabled="isClicked" :loading="isClicked"
                  @click="addForm"                  
                  >
                    Save
                  </v-btn>
                  
                  <v-btn v-if="addedQuestions && formTitle == 'Edit' && addedQuestions.length > 0 "
                  class="success" x-large block depressed tile
                  :block="$mq == 'mobile' ? true : false"
                  :disabled="isClicked" :loading="isClicked"
                  @click="addForm"                  
                  >
                    Update
                  </v-btn>
                </v-flex> -->
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions style="padding: 10px 20px">
          <v-flex xs12 sm12>
            <v-flex xs12 sm12 v-if="assignes.length > 0">
              <h2>Assigned Members</h2>
              <v-chip
                v-for="(user, index) in assignes"
                :key="index"
                class="ma-2"
                color="primary"
                text-color="white"
                label
              >
                <v-avatar left color="#fafafa" style="color: #1a1a1a">
                  {{ user.firstName.substring(0, 1) }}
                </v-avatar>
                {{ user.email }}
              </v-chip>
            </v-flex>

            <v-flex v-else xs12 sm12 style="text-align: center">
              <v-alert border="left" colored-border elevation="2" color="orange">
                <h4
                  style="font-size: 12px; letter-spacing: 0.5px; font-weight: 500; color: #1a1a1a"
                >
                  Currently you dont have any members assigned to this form, please
                  <a href="/#/members">visit</a> the member's page to assign.
                </h4>
              </v-alert>
            </v-flex>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-dialog v-model="loader" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import draggable from "vuedraggable";
import canSee from "@/utilities/canSee";

export default {
  data() {
    return {
      loader: false,
      isClicked: false,
      assignes: [],
      forms: [],
      loading: {
        formOption: true
      },
      active: false,
      networkError: {
        formOption: false
      },
      addedQuestions: [],
      required: false,
      editedIndex: -1,
      setLoading: true,
      editedItem: {
        name: "",
        inputType: "text",
        options: []
      },
      defaultItem: {
        name: "",
        inputType: "text"
      },
      formDesc: "",
      formName: "",
      updateFormId: "",

      formNameRules: [
        v => /^[A-Za-z0-9\-][a-zA-Z0-9 ]+[a-zA-Z0-9]*$/.test(v) || "Enter a valid Form Name"
      ]
    };
  },
  computed: {
    records: {
      get: function() {
        if (this.$store.getters.pagination[this.$router.currentRoute.name]) {
          return this.$store.getters.pagination[this.$router.currentRoute.name];
        } else {
          return "10";
        }
      },
      set: function(val) {
        this.$store.commit("setPagination", {
          name: this.$router.currentRoute.name,
          pagination: val
        });

        //this.getPageDetails()
      }
    },

    formTitle() {
      return this.editedIndex === -1 ? "New" : "Edit";
    }
  },
  created() {
    this.getForms();
    this.getFormDetails();
    // this.getAllUsers();
    this.getAssignes();
    const { updateFormId } = this.$route.params;
    if (typeof updateFormId !== "undefined") {
      this.updateFormId = updateFormId;

      this.editedIndex = 1;
    }
  },
  components: {
    draggable
  },
  methods: {
    getFullName(user) {
      return `${user.firstName} ${user.lastName}`;
    },
    // get all the users  available in this company
    getAllUsers() {
      this.$http
        .get(
          `${this.$store.state.endpoint}Accounts?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          this.allUsers = response.body;
        })
        .catch(err => {
          console.log("Error", err);
        });
    },

    canSee(what, role, options) {
      return canSee(this, what, role, options);
    },

    // get assigned members
    getAssignes() {
      // this.preLoader = true
      this.assignes = [];
      if (typeof this.$route.params.updateFormId !== "undefined") {
        var filter = JSON.stringify({
          where: {
            companyId: this.$store.getters.userDetails.companyId,
            or: [
              { allowedForms: this.$route.params.updateFormId },
              { "fieldTrackingSettings.formId": this.$route.params.updateFormId }
            ]
          }
        });

        this.$http
          .get(`${this.$store.state.endpoint}accounts?filter=` + encodeURIComponent(filter))
          .then(response => {
            this.assignes = response.body;
          })
          .catch(e => {
            this.$swal({ type: "error", text: "Something went wrong" });
          });
        // this.preLoader = false
      }
    },

    getFormDetails() {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}forms?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            this.forms = [];
            this.forms = response.body;
          },
          error => {
            console.log(error);
          }
        );
    },

    getForms() {
      this.loading.formOption = true;

      const self = this;
      // this.setLoading = true
      this.$http.get(`${this.$store.state.endpoint}forms/${this.$route.params.updateFormId}`).then(
        response => {
          self.loading.formOption = false;
          self.formName = response.body.name;
          self.formDesc = response.body.desc
          self.addedQuestions = response.body.formStructures;

          // var arr = response.body
          // for (var i in arr){

          //   if(arr[i].id == this.$route.params.updateFormId){
          //     self.formName = response.body[i].name
          //     self.addedQuestions = response.body[i].formStructures
          //   }
          // }

          // this.setLoading = false
        },
        error => {
          this.loading.formOption = false;
          this.networkError.formOption = true;
          // this.setLoading = false
          // error callback
        }
      );
    },
    addQuestion() {
      if (this.formName == "") {
        this.$swal({
          type: "error",
          text: "Please add a FormName"
        });
        return;
      }
      if (this.editedItem.name == "") {
        this.$swal({
          type: "error",
          text: "Please add a Question"
        });
        return;
      }

      var ques = this.addedQuestions;

      for (var y in ques) {
        if (ques[y].fieldType == "attachmentSignature") {
          if (this.editedItem.inputType == "attachmentSignature") {
            this.$swal({
              type: "error",
              text: "Only one signature options are allowed"
            });

            return;
          }
        }

        if (ques[y].fieldType == "attachmentCapture") {
          if (this.editedItem.inputType == "attachmentCapture") {
            this.$swal({
              type: "error",
              text: "Only one capture image options are allowed"
            });

            return;
          }
        }
      }

      if (this.$refs.formName.validate() == false) {
        this.$swal({
          type: "error",
          text: "Please enter a valid FormName"
        });
      } else {
        let fieldLabel = "";
        const fieldLabelImg = "";
        if (this.editedItem.inputType == "text") {
          fieldLabel = "Text";
        } else if (this.editedItem.inputType == "boolean") {
          fieldLabel = "Yes/No";
        } else if (this.editedItem.inputType == "number") {
          fieldLabel = "Number";
        } else if (this.editedItem.inputType == "date") {
          fieldLabel = "DateTime";
        } else if (this.editedItem.inputType == "option") {
          fieldLabel = "Option";
        } else if (this.editedItem.inputType == "checkbox") {
          fieldLabel = "Checkbox";
        } else if(this.editedItem.inputType == "attachmentSignature") {
          fieldLabel = "Signature";
        } else if(this.editedItem.inputType == "attachmentCapture") {
          fieldLabel = "Capture";
        } else {
          fieldLabel = "Attachment";
        }

        const itemObj = {
          fieldLabel,
          fieldType: this.editedItem.inputType,
          placeHolder: this.editedItem.name,
          answer: "",
          required: this.required
        };

        if (itemObj.fieldType == "option" || itemObj.fieldType == "checkbox") {
          itemObj.options = this.editedItem.options;
        }

        this.addedQuestions.push(itemObj);
        this.editedItem = Object.assign({}, this.defaultItem);
      }
    },
    deleteItem(item) {
      const index = this.addedQuestions.indexOf(item);
      this.addedQuestions.splice(index, 1);
    },

    // assign assignes
    // async assignUsers(id){
    //   try{
    //     var jsonObj = {}

    //     if(this.selectedUsers.length > 0) {
    //       for(var x in this.selectedUsers) {
    //         jsonObj.formsId = id
    //         jsonObj.accountsId = this.selectedUsers[x]
    //         await this.$http.post(`${this.$store.state.endpoint}accountsformslinks`, jsonObj)
    //       }
    //     }

    //   }catch(e){
    //     console.log("err",e)
    //   }

    //   console.log(" -- successful --")
    // },

    // deleteAssignee(user) {
    //   this.$http.delete(`${this.$store.state.endpoint}forms/${this.$route.params.updateFormId}/accounts/rel/${user.id}`)
    //   .then((response) => {
    //
    //     this.$swal({type: "success", text: "Successful"})
    //     this.getAssignes()
    //   })
    //   .catch((err) => {
    //
    //     this.$swal({type: "error", text: "Something went wrong"})
    //   })
    // },

    // Save form
    addForm() {
      this.isClicked = true;

      if (this.editedIndex > -1) {
        const updateObj = {
          name: this.formName,
          formStructures: this.addedQuestions,
          desc: this.formDesc
        };

        this.$http.patch(`${this.$store.state.endpoint}forms/${this.updateFormId}`, updateObj).then(
          response => {
            // success callback
            // this.assignUsers(this.updateFormId)
            this.isClicked = false;
            this.$swal({
              type: "success",
              text: "Form is successfully updated"
            });
            this.getForms();
            this.$router.push("/forms");
          },
          error => {
            // error callback
            this.isClicked = false;
            this.$swal({
              type: "error",
              title: "Oops",
              text: "Something went wrong. Try again later"
            });
          }
        );
      } else {
        const self = this;
        const postObj = {
          name: this.formName,
          companyId: this.$store.state.userDetails.companyId,
          formStructures: this.addedQuestions,
          desc: this.formDesc
        };

        // validation for forms Name
        for (const x in self.forms) {
          if (postObj.name.toLowerCase() == self.forms[x].name.toLowerCase()) {
            self.$swal({ type: "warning", text: "Enter a different form name" });
            this.isClicked = false;
            return;
          }
        }

        this.$http.post(`${this.$store.state.endpoint}forms`, postObj).then(
          response => {
            // this.assignUsers(response.body.id) //assign the selected users

            this.addedQuestions = [];
            this.formName = "";
            this.isClicked = false;

            this.$swal({
              type: "success",
              text: "Form is successfully added"
            });

            this.getForms();
            this.$router.push("/forms");
          },
          error => {
            // console.log(error);
            this.isClicked = false;
            this.$swal({
              type: "error",
              title: "Oops",
              text: "Something went wrong. Try again later"
            });
          }
        );
      }
    }
  }
};
</script>

<style scoped src="./addForm.css"></style>
